import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=cbea6762&scoped=true&"
import script from "./administrators.vue?vue&type=script&lang=js&"
export * from "./administrators.vue?vue&type=script&lang=js&"
import style0 from "./administrators.vue?vue&type=style&index=0&id=cbea6762&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbea6762",
  null
  
)

export default component.exports